import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import { useEffect, useState } from 'react'
import ConfirmationBox from '../../../../components/Dashboard/ConfirmationBox'
import { adminNotificationService } from '../../../../services/admin/notification'
import { useAuthContext } from '../../../../hooks/useAuthContext'
import { toast } from 'react-toastify'

const EmailRedirection = () => {
  const { user } = useAuthContext()

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [emailList, setEmailList] = useState([])

  const [openModal, setOpenModal] = useState(false)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [seletedFromEmailForDelete, setSeletedFromEmailForDelete] = useState('')

  const initialNewData = { from_email: '', to_email: '' }
  const [newData, setNewData] = useState(initialNewData)

  useEffect(() => {
    if (user) {
      ;(async () => {
        setLoading(true)
        const result = await adminNotificationService.getEmailRedirectionData(user)
        setData(result.allEmailRedirections || [])
        setEmailList(result.allEmails || [])
        setLoading(false)
      })()
    }
  }, [user])

  const handleOpenModal = () => {
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
    setNewData(initialNewData)
  }

  const handleSaveData = async () => {
    if (newData.from_email.length == 0 || newData.to_email == 0) {
      toast.error('Please fill all fields.')
      return
    }

    if (newData.from_email === newData.to_email) {
      toast.error("Can't set both fields to the same value.")
      return
    }

    if (data.find((it) => it.from_email == newData.from_email)) {
      toast.error(
        'The Primary Recipient is already set. Please delete the existing Primary Recipient and set a new one.'
      )
      return
    }

    await adminNotificationService.saveEmailRedirectionData(user, newData)

    setData([...data, newData])
    toast.success('Data saved successfully.')
    setOpenModal(false)
    setNewData(initialNewData)
  }

  const handleOnChange = (_, newValue, type) => {
    if (type == 'from_email') {
      setNewData({
        ...newData,
        from_email: newValue,
      })
    }

    if (type == 'to_email') {
      setNewData({
        ...newData,
        to_email: newValue,
      })
    }
  }

  const handleDelete = async () => {
    await adminNotificationService.deleteEmailRedirectionData(user, seletedFromEmailForDelete)

    const updatedData = data.filter((it) => {
      return it.from_email !== seletedFromEmailForDelete
    })

    setData(updatedData)
    toast.success('Deleted Successfully.')
    setSeletedFromEmailForDelete('')
    setOpenDeleteDialog(false)
  }

  if (loading) {
    return (
      <div
        style={{ height: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <CircularProgress color="primary" size={40} />
      </div>
    )
  }

  return (
    <Box mt={2}>
      <Box style={{ display: 'flex', gap: 16, marginBottom: '2rem' }}>
        <Typography variant="h5" fontWeight="bold">
          Email Redirection
        </Typography>
      </Box>
      <Box>
        <Box mb="1rem" sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button color="primary" variant="contained" onClick={handleOpenModal}>
            Add Redirection
          </Button>
        </Box>
        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table stickyHeader sx={{ minWidth: 400 }} aria-label="simple table">
            <TableHead>
              <TableRow component="th" scope="row" style={{ height: '35px' }}>
                <TableCell style={{ fontWeight: 'bold' }}>Primary Recipient</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Alternate Recipient</TableCell>
                <TableCell style={{ width: 100, fontWeight: 'bold' }} align="center">
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((it, index) => (
                <TableRow
                  key={'tr' + index}
                  style={{
                    backgroundColor: index % 2 == 0 ? 'whitesmoke' : 'white',
                    height: '30px',
                  }}
                >
                  <TableCell>{it.from_email}</TableCell>
                  <TableCell>{it.to_email}</TableCell>
                  <TableCell
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  >
                    <IconButton
                      onClick={() => {
                        setSeletedFromEmailForDelete(it.from_email)
                        setOpenDeleteDialog(true)
                      }}
                    >
                      <DeleteOutlineOutlinedIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/*  Add Redirection Modal  */}
      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle> Add Redirection</DialogTitle>
        <DialogContent>
          <Box
            minWidth={400}
            p={'10px'}
            sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
          >
            <Autocomplete
              options={emailList}
              onChange={(e, value) => {
                handleOnChange(e, value, 'from_email')
              }}
              color="primary"
              fullWidth
              id="fromEmail"
              renderInput={(params) => (
                <TextField color="primary" {...params} label="Primary Recipient" />
              )}
            />
            <Autocomplete
              options={emailList}
              onChange={(e, value) => {
                handleOnChange(e, value, 'to_email')
              }}
              fullWidth
              id="toEmail"
              renderInput={(params) => (
                <TextField color="primary" {...params} label="Alternate Recipient" />
              )}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="info" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleSaveData}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation */}
      <ConfirmationBox
        isDialogOpen={openDeleteDialog}
        setIsDialogOpen={setOpenDeleteDialog}
        title={`Are you sure you want to delete the email redirection for ${seletedFromEmailForDelete} ?`}
        onYes={handleDelete}
      />
    </Box>
  )
}

export default EmailRedirection
